import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { ShieldAlert, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

const DctPermitAlerts = () => {
  const [alerts, setAlerts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/api/dct-licensing/alerts`)
      .then(res => setAlerts(res.data.alerts || []))
      .catch(() => {});
  }, []);

  if (alerts.length === 0) return null;

  return (
    <Card className="border-l-4 border-l-orange-400 cursor-pointer hover:shadow-md transition" onClick={() => navigate('/dct-licensing')} data-testid="dct-permit-alerts">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <ShieldAlert className="h-5 w-5 text-orange-500" />
          <h3 className="text-sm font-bold text-orange-700">DCT Permit Alerts</h3>
          <Badge className="bg-orange-100 text-orange-700 text-xs ml-auto">{alerts.length}</Badge>
        </div>
        <div className="space-y-2">
          {alerts.map(a => (
            <div key={a.id} className={`flex items-center justify-between p-2 rounded-lg ${a.status === 'expired' ? 'bg-red-50 border border-red-100' : 'bg-amber-50 border border-amber-100'}`}>
              <div className="flex items-center gap-2">
                <AlertTriangle className={`h-4 w-4 ${a.status === 'expired' ? 'text-red-500' : 'text-amber-500'}`} />
                <div>
                  <p className="text-xs font-semibold text-gray-800">{a.permit_type}</p>
                  <p className="text-[10px] text-gray-500">{a.permit_details || a.permit_no}</p>
                </div>
              </div>
              <Badge className={`text-[10px] ${a.status === 'expired' ? 'bg-red-500 text-white' : 'bg-amber-500 text-white'}`}>
                {a.status === 'expired' ? 'EXPIRED' : `${a.business_days_until_expiry}d left`}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default DctPermitAlerts;
